import { SharedStorageService, SHARED_STORAGE_SERVICE } from './shared-storage.service';
import { HEADER_SERVICE, HeaderService } from './../core/header.service';
import { APP_SHELL_STATE } from './../app-shell.route';
import { StateProvider, UrlRouterProvider } from '@uirouter/angularjs';
import { registerComponentFromTransition } from "../core/lazy-route.helper";
import { sharedStorageComponentOptions, SHARED_STORAGE_COMPONENT } from "./shared-storage.component";

export const SHARED_STORAGE_STATE = "sharedStorageState";


export function configRoute($stateProvider: StateProvider, $urlRouterProvider: UrlRouterProvider) {
    
    $stateProvider.state(SHARED_STORAGE_STATE, {
        parent: APP_SHELL_STATE,
        url: "/sharedstorage",
        views: {
            content: {
                component: SHARED_STORAGE_COMPONENT,
                bindings: { 
                    settings: "settings"
                }
            }
        },
        lazyLoad: async (transition, state) => {
            const moduleExports: any = await import("./shared-storage.component");
            registerComponentFromTransition(transition, SHARED_STORAGE_COMPONENT, moduleExports.sharedStorageComponentOptions);
            return moduleExports;
        },
        resolve: {
            settings: [SHARED_STORAGE_SERVICE, (sharedStorageService: SharedStorageService) => sharedStorageService.getSettings()]
        },
        onEnter: [HEADER_SERVICE, (headerService: HeaderService) => {
            headerService.headerTitle = "Shared Storage"
        }]
    });
}
configRoute.$inject = ["$stateProvider", "$urlRouterProvider"];


// WEBPACK FOOTER //
// ./app/shared-storage/shared-storage.router.ts